var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 101,
    viewBox: "0 0 85 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68701 35.3574C3.68701 35.3574 3.74037 80.4547 4.76947 82.1242C5.79856 83.7936 42.7774 100.747 44.1191 100.343L43.8904 52.0974L3.68701 35.3574Z",
    fill: "#A1C8BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7056 88.909C17.7056 88.909 20.9606 93.8106 28.1566 93.8106V48.3093L17.7056 43.5449V88.9167V88.909Z",
    fill: "#FFAE1F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1642 55.9015V48.3014L17.7131 43.5371V52.9209C21.1663 54.0491 24.6424 55.0706 28.1642 55.9015Z",
    fill: "#FFAE1F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5169 52.2883L44.1191 100.351C44.1191 100.351 80.0155 82.9402 80.3586 81.1031C80.7016 79.2583 81.6468 33.5664 81.6468 33.5664L43.5093 52.296L43.5169 52.2883Z",
    fill: "#52897A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4093 92.2709C60.4093 92.2709 66.7211 91.5391 69.8694 87.3998L70.9595 42.2949L60.2493 45.5575L60.4093 92.2709Z",
    fill: "#EF9926"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.647 55.292L70.9595 42.2949L60.2493 45.5575L60.295 59.0349C63.7787 57.8762 67.2395 56.6489 70.647 55.2997V55.292Z",
    fill: "#EF9926"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.111998 29.0156C0.111998 29.0156 -0.192918 39.238 0.203475 40.6101C0.599868 41.9822 44.8968 60.2468 45.8649 60.6203C45.8649 60.6203 45.5828 48.2254 45.5676 47.7376C45.5447 47.143 0.111998 29.0156 0.111998 29.0156Z",
    fill: "#DFF0EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5674 47.7368L45.8647 60.6196C45.8647 60.6196 83.7507 45.2289 84.3072 43.3765C84.5816 42.4541 85.4354 30.8292 84.0175 30.8673L45.5674 47.7368Z",
    fill: "#78B2A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5676 47.7378L84.0177 30.8682C84.0177 30.8682 43.6543 15.3098 41.7257 15.3556C39.8276 15.4013 0.112061 29.0235 0.112061 29.0235L45.5676 47.7454V47.7378Z",
    fill: "#A1C8BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0017 22.6045L63.4739 39.8781L64.3125 52.9286C64.3125 52.9286 70.1897 53.5536 73.1703 49.079L72.4156 35.9523L27.5775 19.7383C27.5775 19.7383 21.3038 19.784 19.0017 22.6045Z",
    fill: "#FFAE1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8737 20.2091C55.8737 20.2091 62.1778 20.1253 65.288 23.7309L26.4872 39.884L26.3119 52.477C26.3119 52.477 17.7056 51.5318 15.1748 47.7432L15.5026 35.3636L55.8661 20.2168L55.8737 20.2091Z",
    fill: "#FFC91F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5312 5.4755C55.424 -11.7066 40.7879 25.4171 44.3174 29.0151C49.1198 33.9167 88.5761 23.6486 71.5312 5.4755ZM45.3922 28.0928C44.7595 27.239 57.9091 -4.70113 68.1009 8.69238C79.9851 24.3194 46.3832 29.4344 45.3922 28.0928Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2615 7.56445C73.2234 7.90749 73.1852 8.25052 73.1395 8.59355C72.7355 11.5055 71.6683 13.8762 70.5096 16.3385C70.2885 17.4743 69.7778 18.5186 69.0612 19.4791C68.8859 19.8374 68.6572 20.0889 68.398 20.2719C63.1687 25.9586 50.3164 28.3446 46.4745 28.2912C45.6664 28.4132 44.8432 28.4742 44.0046 28.5047C44.0809 28.7105 44.1876 28.8858 44.3096 29.0154C48.9291 33.7264 85.5344 24.4264 73.2538 7.56445H73.2615Z",
    fill: "#FFBB24"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4318 27.7725C46.8864 26.69 47.0084 5.47537 35.6578 10.7657C23.6517 16.3686 41.093 29.2437 44.4318 27.7725ZM36.7098 13.0297C44.3861 8.43307 44.5614 26.8044 44.0812 27.1016C43.3265 27.5666 27.7528 18.3886 36.7098 13.0297Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3847 11.4529C34.3313 11.6283 34.2856 11.8036 34.2398 11.9865C33.8663 13.5035 33.9197 14.8833 34.0035 16.3316C33.8892 16.9338 33.9349 17.5513 34.095 18.1687C34.1103 18.3822 34.1712 18.5499 34.2627 18.6871C35.7187 22.5291 41.5884 26.2491 43.4941 26.9809C43.8676 27.2019 44.264 27.3925 44.668 27.5754C44.5842 27.6593 44.5079 27.7279 44.4165 27.766C41.2072 29.1763 24.978 17.3455 34.3694 11.4453L34.3847 11.4529Z",
    fill: "#FFBB24"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5613 28.9468C48.0908 25.3487 33.4547 -11.775 17.3474 5.40714C0.302548 23.5802 39.7589 33.8483 44.5613 28.9468ZM20.7778 8.62402C30.962 -4.76949 44.1192 27.1706 43.4865 28.0244C42.4955 29.366 8.8936 24.251 20.7778 8.62402Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6172 7.49414C15.6553 7.83717 15.6934 8.18021 15.7391 8.52324C16.1431 11.4352 17.2104 13.8059 18.369 16.2681C18.5901 17.404 19.1008 18.4483 19.8174 19.4088C19.9927 19.7671 20.2214 20.0186 20.4806 20.2016C25.7099 25.8883 38.5622 28.2743 42.4042 28.2209C43.2122 28.3429 44.0355 28.4039 44.874 28.4344C44.7978 28.6402 44.691 28.8155 44.5691 28.9451C39.9496 33.6561 3.34423 24.3561 15.6248 7.49414H15.6172Z",
    fill: "#FFBB24"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5321 18.3972C47.641 12.7181 43.9286 27.3923 45.4303 28.5738C47.4733 30.1823 61.8197 24.4117 54.5321 18.3972ZM45.7962 28.1775C45.5142 27.8878 48.914 15.2337 53.3963 19.777C58.6256 25.0825 46.2307 28.6348 45.7962 28.1775Z",
    fill: "#FFE424"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2791 19.0975C55.2791 19.2271 55.2791 19.3566 55.2791 19.4939C55.2638 20.6068 54.9818 21.5521 54.6692 22.5354C54.6387 22.9699 54.5015 23.3892 54.2728 23.7856C54.2271 23.9304 54.1509 24.0371 54.0594 24.1134C52.3671 26.507 47.6485 28.0315 46.2002 28.1916C45.9029 28.2755 45.5979 28.3365 45.2854 28.3898C45.3235 28.4661 45.3692 28.527 45.4226 28.5652C47.3893 30.1126 60.7142 24.8375 55.2715 19.0898L55.2791 19.0975Z",
    fill: "#FFBB24"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M22.1499 36.4484C25.0161 35.0611 27.9814 33.9557 31.0458 33.102C32.4637 32.7132 31.8615 30.5025 30.436 30.8989C27.1734 31.7984 24.0327 33.0029 20.9912 34.4741C19.6648 35.1144 20.8235 37.0888 22.1422 36.4484H22.1499Z",
    fill: "#FFE424"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M17.8123 39.206C17.6904 40.8297 17.576 42.4534 17.4541 44.0771C17.3473 45.5483 19.6342 45.5407 19.7409 44.0771C19.8629 42.4534 19.9773 40.8297 20.0992 39.206C20.2059 37.7348 17.9191 37.7424 17.8123 39.206Z",
    fill: "#FFE424"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M56.2702 34.0073C59.7005 35.1584 63.1308 36.3018 66.5535 37.4529C67.9485 37.9179 68.5507 35.7149 67.1633 35.2499C63.733 34.0988 60.3027 32.9554 56.88 31.8043C55.485 31.3393 54.8828 33.5423 56.2702 34.0073Z",
    fill: "#FFC91F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M68.6498 39.3065C68.6879 40.9302 68.6574 42.5463 68.566 44.17C68.4821 45.6412 70.769 45.6336 70.8529 44.17C70.9443 42.5539 70.9748 40.9302 70.9367 39.3065C70.9062 37.8353 68.6193 37.8353 68.6498 39.3065Z",
    fill: "#FFC91F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M19.7867 76.5761C19.8019 78.4971 19.8248 80.418 19.8401 82.339C19.8553 83.8102 22.1422 83.8102 22.1269 82.339C22.1117 80.418 22.0888 78.4971 22.0736 76.5761C22.0583 75.1048 19.7715 75.1048 19.7867 76.5761Z",
    fill: "#FFC91F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M19.8018 63.2206C19.8323 66.3613 19.8628 69.5095 19.8857 72.6502C19.9009 74.1214 22.1878 74.1214 22.1726 72.6502C22.1421 69.5095 22.1116 66.3613 22.0887 63.2206C22.0735 61.7494 19.7866 61.7494 19.8018 63.2206Z",
    fill: "#FFC91F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M66.6754 59.08C66.5687 63.608 66.523 68.1437 66.5535 72.6793C66.5611 74.1505 68.848 74.1505 68.8403 72.6793C68.8099 68.1437 68.8556 63.6156 68.9623 59.08C69.0004 57.6088 66.7135 57.6088 66.6754 59.08Z",
    fill: "#FFAE1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M66.6144 77.0011C66.4543 78.9983 66.5 80.9879 66.7516 82.9775C66.9345 84.4182 69.2214 84.4335 69.0385 82.9775C68.7869 80.9879 68.7412 79.0059 68.9013 77.0011C69.0232 75.5375 66.7363 75.5451 66.6144 77.0011Z",
    fill: "#FFAE1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26837 30.3186C11.2489 29.4191 14.2066 28.4281 17.1262 27.3533C18.4983 26.8502 17.9038 24.6395 16.5164 25.1503C13.5892 26.2251 10.6391 27.2085 7.65853 28.1156C6.25591 28.5425 6.8505 30.7455 8.26837 30.3186Z",
    fill: "#DFF0EB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69198 48.0722C5.51665 53.5073 5.50903 58.9349 5.65386 64.37C5.69198 65.8412 7.97886 65.8412 7.94075 64.37C7.79591 58.9349 7.80353 53.5073 7.97886 48.0722C8.0246 46.6009 5.73771 46.6009 5.69198 48.0722Z",
    fill: "#DFF0EB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80623 68.1757C5.74525 70.0204 5.73762 71.8576 5.77574 73.7023C5.80623 75.1735 8.09311 75.1735 8.06262 73.7023C8.02451 71.8576 8.03975 70.0204 8.09311 68.1757C8.13885 66.7045 5.85197 66.7045 5.80623 68.1757Z",
    fill: "#DFF0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift_icon.1c367c77d35053f996c9807154d7bad0.svg";
export { ForwardRef as ReactComponent };